<template>
    <div class="config-content">
        <nav-tabs
            :tabs="contentInfo.navTabsInfo"
        />
        <div class="tab-content">
            <template v-for="(tab, index) in contentInfo.navTabsInfo">
                <div
                    :id="tab.link"
                    :key="'tab-pane-' + index"
                    :class="{ active: activeSubtab == tab.link, [`${tab.slug}-tab`]: true }"
                    :data-tab-disabled="Boolean(disabledRules[tab.slug]) && activeSubtab == tab.link"
                    class="tab-pane"
                >
                    <template v-for="(row, rowIndex) in contentInfo.rowsContent">
                        <template v-for="data in row.data">
                            <tab-row
                                v-if="row.id == tab.link && row.type == 'standard'"
                                :key="'tab-' + index + '-row-' + rowIndex + data.id"
                                :part-name="row.partName"
                                :buttons-type="row.buttonsType"
                                :row-data="data"
                                :row-structure="row"
                                :can-deselect="row.canDeselect"
                                :tab-disabled="!!disabledRules[tab.slug]"
                                :tab-slug="tab.slug"
                            />
                            <tab-row-inner-tabs
                                v-if="row.id == tab.link && row.type == 'innerTabs'"
                                :key="'tab-' + index + '-row-' + rowIndex + data[rowIndex].id"
                                :part-name="row.partName"
                                :buttons-type="row.buttonsType"
                                :row-content="data"
                                :row-structure="row"
                                :tab-disabled="!!disabledRules[tab.slug]"
                                :tab-slug="tab.slug"
                            />
                            <tab-row-colors
                                v-if="row.id == tab.link && row.type == 'colors'"
                                :key="'tab-' + index + '-row-' + rowIndex + data.id"
                                :row-data="data"
                                :part-name="row.partName"
                            />
                        </template>
                    </template>
                    <disabled-message v-if="disabledRules[tab.slug]" :message="disabledRules[tab.slug]" />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import DisabledMessage from "./components/tab-row/components/disabled-message";
import TabRow from "./components/tab-row/tab-row";
import TabRowInnerTabs from "./components/tab-row/tab-row-inner-tabs";
import TabRowColors from "./components/tab-row/tab-row-colors";
import NavTabs from "./components/nav-tabs";

export default {
    name: "TabContent",
    components: {
        DisabledMessage,
        TabRow,
        NavTabs,
        TabRowInnerTabs,
        TabRowColors
    },
    props: {
        contentInfo: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState({
            disableRules: state => state.Step4.disableRules,
            activeSubtab: state => state.Step4.activeSubtabs[state.Step4.activeTab]
        }),
        disabledRules() {
            const disabledRules = {};

            this.contentInfo.navTabsInfo.forEach(tab => {
                const rule = this.disableRules.find(rule => rule.ruleType == "disable-all" && rule.partToChange == tab.slug);

                if (rule) {
                    disabledRules[tab.slug] = rule.msg;
                }
            });

            return disabledRules;
        }
    }
}
</script>

<style lang="scss" scoped>
@media only screen and (max-device-width: 1024px) and (min-device-width: 768px) and (orientation : landscape) {
    .config-content {
        .tab-content {
            padding-bottom: 100px;
        }
        
        .limited-cases-tab {
            width: 100%;
        }
    }
}
</style>
